import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Platform, IonicModule } from '@ionic/angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs/operators';

import { BiometricService } from 'src/app/services/biometric/biometric.service';
import { ComponentsModule } from "../components.module";
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { LocationWarningService } from 'src/app/services/location-warning/location-warning.service';
import { NavbarStateSelectorComponent } from '../navbar-state-selector/navbar-state-selector.component';
import { Navigator } from 'src/app/services/routing/navigator';
import { RglogoComponent } from '../rglogo/rglogo.component';
import { SiteLogoComponent } from './site-logo/site-logo.component';
import { TopBarComponent } from '../navigation-bar/top-bar/top-bar.component';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@UntilDestroy()
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ComponentsModule,
    IonicModule,
    NavbarStateSelectorComponent,
    RglogoComponent,
    SiteLogoComponent,
    TopBarComponent,
  ]
})
export class NavbarComponent implements OnInit {

  public displayRGLogo: boolean;
  public displayStateSwitcher: boolean;
  public isAuthenticated: boolean;
  public isMobileWeb: boolean = false;

  constructor(
    private biometric: BiometricService,
    private config: ConfigService,
    private events: EventsService,
    private locationWarning: LocationWarningService,
    private navigator: Navigator,
    private platform: Platform,
    private userSession: UserSessionService,
  ) { }

  ngOnInit() {

    this.displayRGLogo = this.config.isEnabled('FEATURE_SHOW_RG_LOGO');
    this.displayStateSwitcher = this.config.isEnabled('FEATURE_SHOW_STATE_SWITCH_SELECTOR');

    this.isMobileWeb = this.platform.is('mobileweb');
    this.verifyAuth();

    this.events.subscribe("event:login", () => this.verifyAuth());
    this.events.subscribe("event:authentication:logout", () => this.verifyAuth());
  }

  private verifyAuth(): void {
    this.userSession.sessionToken$
      .pipe(
        map(token => !!token),
        untilDestroyed(this)
      )
      .subscribe(() => {
        this.isAuthenticated = this.userSession.isAuthenticated();
      });
  }

  public joinNow(): void {
    const isLocationWarningEnabled = this.config?.isEnabled('FEATURE_LOCATION_WARNING_ON_JOIN');
    const hideBoydRewards = this.config?.isEnabled('BOYD_REWARDS_HIDE', true);
    const locationAllowed = this.locationWarning?.locationIsAllowed();

    if (isLocationWarningEnabled && !locationAllowed) {
      this.navigateTo('SignupStepOneComponent', '', { connectBoydCardPath: false });
      this.locationWarning.openLocationWarning('join', { connectBoydCardPath: false });
      return;
    }

    const targetComponent = !hideBoydRewards ? 'SignupOptionsComponent' : 'SignupStepOneComponent';
    this.navigateTo(targetComponent, '', { connectBoydCardPath: false });
  }

  async handleLogin() {
    if (this.config.isBiometricEnabled() && this.platform.is('capacitor')) {
      const loginSucess = await this.biometric.biometricLoginInitiator();
      if (!loginSucess) this.navigator.navigateTo('LoginComponent', "", { biometricVerificationFailed: true });
    } else {
      this.navigateTo('LoginComponent')
    }
  }

  public navigateTo(page: string, options?, params?): any {
    return this.navigator.navigateTo(page, options, params);
  }
}